export default "__VITE_ASSET__rlckv_RM__"